import { render, staticRenderFns } from "./PartnershipManagerShow.vue?vue&type=template&id=10476997&"
import script from "./PartnershipManagerShow.vue?vue&type=script&lang=js&"
export * from "./PartnershipManagerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports